import script from "./EditMiddleMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditMiddleMenu.vue?vue&type=script&lang=ts&setup=true"

import "./EditMiddleMenu.vue?vue&type=style&index=0&id=79c510ef&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79c510ef"]])

export default __exports__